import { type AppIconName } from '@web/ui/core/atoms';

/**
 * Icon representing an agent by kind on board surfaces: AI agents show a
 * `sparkle`, human agents a `headset`. Centralises the mapping shared by the
 * conversation card, the tasks list and the card-detail sub-header.
 */
export function agentKindIcon(kind: 'agent' | 'operator'): AppIconName {
  return kind === 'agent' ? 'sparkle' : 'headset';
}
